import React from "react";

import ParallaxImage from "../ParallaxImage";
import { ReactLenis } from "@studio-freight/react-lenis";
import "../../css/SelectionBg.css";
import InteriorDesignResidentialSelectionComponent from "../InteriorDesignComponents/InteriorDesignResidentialSelection";
import LuxeSelection from "../Selection2/LuxeSelection";
import BeysuSelection from "../Selection2/BeysuSelection";
import CommercialSelectionComponent from "./CommercialSelectionComponent";
import MagellanSelection from "../Selection2/MagellanSelection";
import MagellanShow from "./commercialimagesshow/MagellanShow";
import DawlanceSelection from "../Selection2/DawlanceSelection";
import AzelSelection from "../Selection2/AzelSelection";
import AzelShow from "./commercialimagesshow/AzelShow";
import AzelShow2 from "./commercialimagesshow/AzelShow2";

export default function AzelComponent() {
  return (
    <ReactLenis root>
      <div className="app1">
        <section className="hero">
          <div className="img">
            <ParallaxImage
              src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/2B3.jpg"
              alt=""
            />
          </div>

          <div className="nav">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                paddingTop: "200px",
              }}
            >
              <p className="p5"> Azel Law Office</p>
              {/* <p>COMMERCIAL INTERIOR DESIGN</p>
              <p>EXTERIOR DESIGN</p> */}
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  paddingLeft: "10px",
                  color: "#e7e7e7",
                  textTransform: "uppercase",
                  fontSize: "20px",
                }}
              >
                <span>
                  role in project: Architectural drawings, 3d drawings, project
                  execution
                </span>
                <span>project duration: 2 months</span>
                <span>year of completion: 2020</span>
                <span>project location:Cankaya, Ankara-TURKIYE</span>
              </div>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage
                src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/B1.jpg"
              alt=""
            />
          </div>

          {/* <div className="projects-brief">
              <p
                style={{
                    color:"black",
                    fontSize:"30px"
                }}
              >
              This modern living space and bedroom are designed to inspire with its elegant lines, warm tones, and luxurious finishes, creating an inviting ambiance for both relaxation and entertaining.
              </p>
            </div> */}

          <div className="col projects-cover">
            <div
              className="img"
              style={{
                marginTop: "1000px",
                zIndex: "9999",
              }}
            >
              <ParallaxImage
               src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/5B2.jpg"
                alt=""
              />
            </div>
          </div>

          <div className="col projects-list">
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Modern,
                <br />
                Professional,
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Stylist,
                <br />
                Practical
              </h1>
            </div>
            <div className="project">
              <h1
                style={{
                  paddingRight: "550px",
                  textAlign: "right",
                  textTransform: "uppercase",
                }}
              >
                Elegant,
                <br />
                Functional
              </h1>
            </div>
          </div>
        </section>

        <section className="projects">
          <div className="img">
            <ParallaxImage src="../../Images/Untitled.png" alt="" />
          </div>

          <div className="projects-brief">
            <p
              style={{
                color: "#dbccc0",

                paddingLeft: "350px",
                width: "800px",
                fontSize: "35px",
                textAlign: "left",
              }}
            >
          "This law office project combines modern style with practical design, creating a sophisticated and functional space that reflects the professionalism of the legal profession, with carefully curated details, neutral tones, and metallic accents, ensuring both aesthetic appeal and operational efficiency."
            </p>
          </div>

          <div className="col projects-cover">
            <div className="img" style={{}}>
              <ParallaxImage
                src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/5B2.jpg"
                alt=""
              />
            </div>
          </div>

          <div
            className="col projects-list"
            style={{
              opacity: "0",
            }}
          >
            <div className="project">
              <h1>A Perfect Blend</h1>
            </div>
            <div className="project">
              <h1>Blend of Style and Comfort</h1>
            </div>
            <div className="project">
              <h1>Comfort</h1>
            </div>
            <div className="project">
              <h1>2024</h1>
            </div>
          </div>
        </section>

        <section className="about">
          <div className="col intro">
            <p>ABOUT</p>
            <p
              style={{
                width: "450px",
              }}
            >
         The law office project highlights a combination of modern style and practical design, shaped to reflect the professionalism and standing of the legal profession. We managed the entire design process, covering initial concepts, 3D renderings, and precise architectural plans.
              <br />
              <br />
              The design includes simple lines, a neutral color scheme with metallic touches, and carefully chosen furniture to create a space that feels both stylish and professional. From the ceiling details to the selected furniture, every aspect was thoughtfully planned to balance visual appeal and usefulness. We also oversaw the execution phase, ensuring that every detail was handled with care, resulting in a workspace that blends practicality and aesthetics.

            </p>
          </div>
          <div className="col portrait">
            <div className="portrait-container">
              <div className="img">
                <ParallaxImage
                    src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/3B3.jpg"
                  alt=""
                />
              </div>
            </div>
          </div>
        </section>

        <section className="banner">
          <AzelSelection />
        </section>

        <section className="banner">
          <div className="img">
            <ParallaxImage
          src="../../Images/CommercialImages/11-AzelLawOffice/RENDER/b2b.jpg"
              alt=""
            />
          </div>

          {/* <div className="banner-copy">
              <p
              
              >Location:</p>
              <h1
                style={{
                    color:"#1a1a1a"
                }}
              >Yenimahalle, </h1>
             <h1
               style={{
                color:"#1a1a1a"
            }}
             >Ankara-TURKIYE</h1>
            
            </div> */}
        </section>

        {/* <section className="footer1">
          <div className="col">
            <p>Instagram</p>

            <div className="footer-links">
              <p>Luxe Residance</p>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                "A Perfect Blend
              </h1>
              <h1> of Style and Comfort."</h1>
              <h1
                style={{
                  fontSize: "40px",
                }}
              >
                A2Z Design & Build
              </h1>
            </div>
          </div>

       
          <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div>
        </section> */}

        <section className="footer2">
          <div className="col2">
            <div className="footer-links">
              <h1
                style={{
                  textAlign: "center",
                  fontSize: "40px",
                }}
              >
              "Where Modern Design Meets Legal Professionalism."
              </h1>
              <p>A2Z Design Studio</p>
            </div>
          </div>

          {/* <div className="col">
              <p>
                Join the newsletter <br />
                <button>Subscribe</button>
              </p>
  
              <div className="shop">
                <div className="img">
                  <ParallaxImage src="../Images/landingpageimage/image8.jpg" alt="" />
                </div>
              </div>
  
              <p>Spotify / Apple Music / Youtube</p>
            </div> */}
        </section>
        <div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100"
            }}
          >
          3d visualizations
          </h1>
          <AzelShow/>
        </div>
        <div>
        <h1
            style={{
              marginBottom:"20px",
              textAlign:"center",
              textTransform:"uppercase",
              fontSize:"35px",
              fontWeight:"100",
              marginTop:"50px"
            }}
          >
          completed projects
          </h1>
          <AzelShow2/>
        </div>
     
     
        <CommercialSelectionComponent />
      </div>
    </ReactLenis>
  );
}
